
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMosfetPtype2On as ObiMosfetPtype2OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-mosfet-ptype-2-on.js';
 
 
 

 
 export const ObiMosfetPtype2On = createComponent({
   react: React,
   tagName: 'obi-mosfet-ptype-2-on',
   elementClass: ObiMosfetPtype2OnElement,
   events: {
     
   }
  });
 
 